interface AppPreloaderProps {
    progress?: number;
}

export default function AppPreloader({ progress = 0 }: AppPreloaderProps) {
    // If children are provided, we just render them (this component acts as a wrapper?)
    // But in App.tsx it's used as a return: if (loading) return <AppPreloader />
    // So if we are here, we are loading.
    
    return (
        <div style={{
            height: '100vh',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#f8fafc',
            flexDirection: 'column',
            gap: '16px'
        }}>
            <div style={{
                width: '40px',
                height: '40px',
                border: '3px solid #e2e8f0',
                borderTopColor: '#3b82f6',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite'
            }} />
            <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
            <span style={{ fontFamily: 'sans-serif', color: '#64748b', fontSize: '14px' }}>
                Loading Visual Tools... {Math.round(progress)}%
            </span>
            {/* Optional progress bar */}
            <div style={{ width: '200px', height: '4px', background: '#e2e8f0', borderRadius: '2px', marginTop: '8px' }}>
                <div style={{ 
                    width: `${progress}%`, 
                    height: '100%', 
                    background: '#3b82f6', 
                    borderRadius: '2px',
                    transition: 'width 0.3s ease'
                }} />
            </div>
        </div>
    );
}
